(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal) {
        this.searchModal.close(false);
      }
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vaylea-fit-guide"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('vaylea-fit'))customElements.define('vaylea-fit',class extends HTMLElement{
connectedCallback(){if(this.ready)return;this.ready=true;this.abort=new AbortController();this.messages=JSON.parse(this.querySelector('[data-messages]').textContent);this.addEventListener('change',()=>this.update(),{signal:this.abort.signal});this.querySelector('[data-reset]').addEventListener('click',()=>{this.querySelectorAll('input').forEach(el=>el.checked=false);this.querySelector('select').value='unknown';this.update();},{signal:this.abort.signal});}
update(){const setup=this.querySelector('input:checked')?.value;this.querySelector('.vf-connection').hidden=setup!=='handheld';let result;if(setup==='handheld'){const choice=this.querySelector('select').value;result=this.messages[choice==='yes'?'match':choice==='other'?'other':'check'];}else result=this.messages[setup];this.querySelector('[data-result-title]').textContent=result?result[0]:this.messages.initial;const body=this.querySelector('[data-result-body]');body.textContent=result?result[1]:'';if(setup==='unsure'||(setup==='handheld'&&this.querySelector('select').value==='other')){const email=document.createElement('a');email.href='mailto:hello@vayleawellness.com?subject=Help%20checking%20my%20shower%20fitting';email.textContent='hello@vayleawellness.com';body.append(' ',email);}this.dispatchEvent(new CustomEvent('vaylea:interaction',{bubbles:true,detail:{action:'fit_check',value:setup||'reset'}}));}
disconnectedCallback(){this.abort?.abort();this.ready=false;}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vaylea-rovia-buy"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('vaylea-buy')) {
  customElements.define('vaylea-buy', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.abort = new AbortController();
      const options = {signal:this.abort.signal};
      this.form = this.querySelector('form');
      this.variants = JSON.parse(this.querySelector('[data-variants]').textContent);
      this.labels = JSON.parse(this.querySelector('[data-labels]').textContent);
      this.money = new Intl.NumberFormat(document.documentElement.lang || 'en-GB', {style:'currency',currency:this.dataset.currency || 'GBP'});
      this.querySelectorAll('[data-tab]').forEach(button => {
        button.addEventListener('click', () => this.showTab(button.dataset.tab), options);
        button.addEventListener('keydown', event => {
          const tabs = [...this.querySelectorAll('[data-tab]')];
          let target;
          if (event.key === 'ArrowRight') target = tabs[(tabs.indexOf(button)+1)%tabs.length];
          if (event.key === 'ArrowLeft') target = tabs[(tabs.indexOf(button)-1+tabs.length)%tabs.length];
          if (event.key === 'Home') target=tabs[0];
          if (event.key === 'End') target=tabs[tabs.length-1];
          if (target) {event.preventDefault();this.showTab(target.dataset.tab);target.focus();}
        }, options);
      });
      this.form.addEventListener('change', event => {
        if(event.target.name==='bundle_quantity')this.quantityInput.value=event.target.value;
        this.update(event.target.name==='id');
      }, options);
      this.form.addEventListener('input', event => {if(event.target.name==='quantity')this.update(false);}, options);
      this.querySelector('[data-gallery-prev]').addEventListener('click',()=>this.stepGallery(-1),options);
      this.querySelector('[data-gallery-next]').addEventListener('click',()=>this.stepGallery(1),options);
      this.bundleMode=this.dataset.bundlesEnabled==='true';
      this.quantityInput=this.form.elements.quantity;
      if(this.bundleMode){
        this.querySelector('[data-bundle-options]').hidden=false;
        this.quantityInput.closest('label').hidden=true;
        this.form.addEventListener('submit',event=>this.submitBundle(event),options);
      }
      this.showTab(location.hash==='#rovia-video'&&this.querySelector('[data-tab="video"]')?'video':this.querySelector('[data-tab]').dataset.tab);
      document.addEventListener('click',event=>{const link=event.target.closest('a[href="#rovia-video"]');if(link)this.showTab('video');},options);
      if(this.bundleMode)this.quantityInput.value=this.form.querySelector('[name="bundle_quantity"]:checked').value;
      this.update(false);
      const mainButton=this.querySelector('.vb-submit');
      const sticky=this.querySelector('.vb-sticky');
      if ('IntersectionObserver' in window) {
        this.observer=new IntersectionObserver(entries => {sticky.hidden=entries[0].isIntersecting;});
        this.observer.observe(mainButton);
      }
      sticky.querySelector('button').addEventListener('click',event=>{
        if(this.form.getBoundingClientRect().top>window.innerHeight || this.form.getBoundingClientRect().bottom<0){event.preventDefault();this.form.scrollIntoView({behavior:'smooth',block:'center'});this.form.querySelector('input:not([type="hidden"]):not(:disabled)')?.focus({preventScroll:true});}
      },options);
    }
    stepGallery(direction){
      const tabs=[...this.querySelectorAll('[data-tab]')];
      const index=tabs.findIndex(tab=>tab.getAttribute('aria-selected')==='true');
      const next=tabs[(index+direction+tabs.length)%tabs.length];
      this.showTab(next.dataset.tab);
    }
    showTab(name,scrollTab=false) {
      if (!this.querySelector('[data-tab="'+name+'"]')) return;
      this.querySelectorAll('[data-tab]').forEach(button=>{const active=button.dataset.tab===name;button.setAttribute('aria-selected',String(active));button.tabIndex=active?0:-1;});
      this.querySelectorAll('[data-panel]').forEach(panel=>{panel.hidden=panel.dataset.panel!==name;if(panel.hidden)panel.querySelectorAll('video').forEach(video=>video.pause());});
      const tabs=[...this.querySelectorAll('[data-tab]')];
      const active=tabs.find(tab=>tab.dataset.tab===name);
      this.querySelector('[data-gallery-position]').textContent=(tabs.indexOf(active)+1)+' / '+tabs.length;
      if(scrollTab)active?.scrollIntoView({behavior:'smooth',block:'nearest',inline:'nearest'});
      this.dispatchEvent(new CustomEvent('vaylea:interaction',{bubbles:true,detail:{action:'gallery',value:name}}));
    }
    update(showFinish) {
      const id=this.form.querySelector('[name="id"]:checked')?.value;
      const variant=this.variants.find(v=>String(v.id)===id);
      if(!variant)return;
      const raw=Number(this.form.elements.quantity.value);
      const quantity=Number.isInteger(raw)&&raw>0?raw:1;
      const bundleQuantity=this.bundleMode?Number(this.form.querySelector('[name="bundle_quantity"]:checked').value):quantity;
      const offerTotal=this.bundleMode?({1:3499,2:4999,3:6499}[bundleQuantity]):variant.price*quantity;
      if(this.bundleMode){
        this.querySelector('.vb-extra-finishes').hidden=bundleQuantity<2;
        this.form.querySelectorAll('[data-extra-finish-group]').forEach(group=>{
          const show=Number(group.dataset.showerNumber)<=bundleQuantity;
          group.hidden=!show;
          group.querySelectorAll('[data-extra-finish]').forEach(input=>{input.disabled=!show||input.dataset.available!=='true';});
        });
      }
      this.querySelectorAll('[data-unit-price]').forEach(el=>el.textContent=this.money.format((this.bundleMode?offerTotal:variant.price)/100));
      this.querySelectorAll('[data-total-price]').forEach(el=>el.textContent=this.money.format(offerTotal/100));
      const extras=[...this.form.querySelectorAll('[data-extra-finish]:checked:not(:disabled)')];
      const finishCounts=new Map();
      [variant,...extras.map(input=>this.variants.find(v=>String(v.id)===input.value))].filter(Boolean).forEach(v=>finishCounts.set(v.title,(finishCounts.get(v.title)||0)+1));
      const finishSummary=this.bundleMode&&bundleQuantity>1?[...finishCounts].map(([title,count])=>count+' × '+title).join(' + '):variant.title;
      this.querySelectorAll('[data-variant-name]').forEach(el=>el.textContent=finishSummary);
      const available=variant.available&&extras.length===(this.bundleMode?bundleQuantity-1:0)&&extras.every(input=>this.variants.some(v=>String(v.id)===input.value&&v.available));
      this.querySelectorAll('.vb-submit,[data-sticky-add]').forEach(el=>{el.disabled=!available;el.textContent=available?this.labels.add:this.labels.sold;});
      if(showFinish) {
        this.querySelectorAll('.vb-kit-finish-image').forEach(img=>{if(variant.kitImage){img.src=variant.kitImage;img.removeAttribute('srcset');img.alt='ROVIA showerhead — '+variant.title;}});
        const url=new URL(location.href);url.searchParams.set('variant',variant.id);history.replaceState({},'',url);
      }
    }
    async submitBundle(event){
      const quantity=Number(this.form.querySelector('[name="bundle_quantity"]:checked').value);
      if(quantity===1)return;
      event.preventDefault();
      if(this.submitting)return;
      this.submitting=true;
      const error=this.querySelector('[data-bundle-error]');error.textContent='';
      const buttons=[...this.querySelectorAll('.vb-submit,[data-sticky-add]')];
      buttons.forEach(button=>{button.disabled=true;button.textContent=this.labels.adding;});
      const data=new FormData(this.form);
      const properties={};
      for(const [key,value] of data.entries()){const match=key.match(/^properties\[(.+)\]$/);if(match)properties[match[1]]=value;}
      const ids=[data.get('id'),...[...this.form.querySelectorAll('[data-extra-finish]:checked:not(:disabled)')].map(input=>input.value)];
      const grouped=new Map();
      ids.forEach(id=>{if(grouped.has(id))grouped.get(id).quantity+=1;else grouped.set(id,{id:Number(id),quantity:1,properties});});
      try{
        const root=window.Shopify?.routes?.root||'/';
        const response=await fetch(root+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[...grouped.values()]})});
        if(!response.ok){let detail;try{detail=await response.json();}catch{}throw new Error(detail?.description||this.labels.error);}
        window.location.assign(root+'cart');
      }catch(failure){error.textContent=failure.message||this.labels.error;this.submitting=false;this.update(false);}
    }
    disconnectedCallback(){this.abort?.abort();this.observer?.disconnect();this.ready=false;}
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vaylea-spray-modes"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('toggle',event=>{if(event.target.matches?.('.vm-demo')&&!event.target.open)event.target.querySelector('video')?.pause();},true);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vaylea-welcome-offer"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('vaylea-welcome')){
customElements.define('vaylea-welcome',class extends HTMLElement{
connectedCallback(){
if(this.ready)return;this.ready=true;this.abort=new AbortController();const opts={signal:this.abort.signal};this.dialog=this.querySelector('dialog');
this.querySelectorAll('[data-open]').forEach(b=>b.addEventListener('click',()=>this.open(),opts));
this.querySelectorAll('[data-close]').forEach(b=>b.addEventListener('click',()=>{this.returnToTop=b.hasAttribute('data-return-top');this.dialog.close();},opts));
this.dialog.addEventListener('click',event=>{if(event.target===this.dialog){const r=this.dialog.getBoundingClientRect();if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom)this.dialog.close();}},opts);
this.dialog.addEventListener('close',()=>{
this.save('session','vaylea-welcome-seen','1');
if(this.returnToTop){
this.returnToTop=false;
if(location.hash==='#vaylea-delivery-offer')history.replaceState(history.state,'',location.pathname+location.search);
document.querySelector('main')?.focus({preventScroll:true});
window.scrollTo({top:0,left:0,behavior:'instant'});
}else{this.previous?.focus?.({preventScroll:true});}
},opts);
document.addEventListener('click',event=>{const a=event.target.closest?.('a[href="#vaylea-delivery-offer"]');if(a){event.preventDefault();this.open();}},opts);
const response=this.querySelector('[data-response]');
if(response){if(response.dataset.response==='success')this.save('local','vaylea-welcome-member','1');this.open();}
else if(location.hash==='#vaylea-delivery-offer')this.open();
else if(this.dataset.auto==='true'&&this.dataset.design!=='true'&&!this.read('session','vaylea-welcome-seen')&&!this.read('local','vaylea-welcome-member')){
this.timer=setTimeout(()=>{const active=document.activeElement;if(document.visibilityState==='hidden'||active?.matches('input,textarea,select,[contenteditable=true]')||document.querySelector('dialog[open]'))return;this.open();},Number(this.dataset.delay)||5000);
}
}
read(type,key){try{return(type==='local'?localStorage:sessionStorage).getItem(key);}catch{return null;}}
save(type,key,value){try{(type==='local'?localStorage:sessionStorage).setItem(key,value);}catch{}}
open(){if(this.dialog.open||typeof this.dialog.showModal!=='function')return;this.returnToTop=false;this.previous=document.activeElement;this.save('session','vaylea-welcome-seen','1');this.dialog.showModal();this.querySelector('input[type=email]')?.focus({preventScroll:true});}
disconnectedCallback(){clearTimeout(this.timer);this.abort?.abort();if(this.dialog?.open)this.dialog.close();this.ready=false;}
});
}

  } catch(e) { console.error(e); }
})();
})();
